/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankDtoApiResponse } from '../../models/bank-dto-api-response';
import { EditCustomerBankCommand } from '../../models/edit-customer-bank-command';

export interface EditBankAsync$Plain$Params {
  id: number;
  bankId: number;
      body?: EditCustomerBankCommand
}

export function editBankAsync$Plain(http: HttpClient, rootUrl: string, params: EditBankAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editBankAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('bankId', params.bankId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BankDtoApiResponse>;
    })
  );
}

editBankAsync$Plain.PATH = '/api/customer/{id}/bank/{bankId}';
